import { Helmet } from "react-helmet-async"
import { useParams } from "react-router-dom";
import InitialDueDiligenceView from "../../../components/dashboard/transitions/InitialDueDiligence/InitialDueDiligenceView";

export default function AddPortfolio() {
  const { id } = useParams();
  return <>
    <Helmet>
      <title>{ id ? '' : 'Add '} Portfolio | Platform Solutions</title>
    </Helmet>
    <InitialDueDiligenceView />
  </>
}